export enum Severity {
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  SUCCESS = 'success',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
